import { useState, useRef, useEffect } from "react";
import "./phoneInput.css";

const COUNTRIES = [
	{ label: "DO +1", value: "+1" },
	{ label: "CA +1", value: "+1" },
	{ label: "US +1", value: "+1" },
];

const PhoneInput = ({ businessPhone = "", setBusinessPhone, className = "" }) => {
	const [countryCode, setCountryCode] = useState("+1");
	const [countryLabel, setCountryLabel] = useState("DO +1");
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [localNumber, setLocalNumber] = useState("");
	const dropdownRef = useRef(null);

	// ---------- Helpers ----------
	// UI format: 123-456-7890
	const formatNumber = (value) => {
		const digits = value.replace(/\D/g, "").slice(0, 10);
		if (digits.length > 6) return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
		if (digits.length > 3) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
		return digits;
	};

	// Backend format: +15551234567
	const toE164 = (code, formattedNumber) => {
		const onlyDigits = formattedNumber.replace(/\D/g, "");
		return code + onlyDigits;
	};

	// ---------- On number typing ----------
	const handleChange = (e) => {
		const rawDigits = e.target.value.replace(/\D/g, "").slice(0, 10);
		const formatted = formatNumber(rawDigits);

		setLocalNumber(formatted);
		setBusinessPhone(toE164(countryCode, formatted)); // normalized!
	};

	// ---------- On country selection ----------
	const handleSelect = (label, value) => {
		setCountryLabel(label);
		setCountryCode(value);
		setDropdownOpen(false);

		setBusinessPhone(toE164(value, localNumber)); // normalized!
	};

	// ---------- Sync when parent updates ----------
	useEffect(() => {
		if (businessPhone) {
			const match = COUNTRIES.find((c) => businessPhone.startsWith(c.value));

			if (match) {
				setCountryCode(match.value);
				setCountryLabel(match.label);

				const num = businessPhone.replace(match.value, "").replace(/\D/g, "");
				setLocalNumber(formatNumber(num));
			}
		} else {
			setLocalNumber("");
		}
	}, [businessPhone]);

	// ---------- Close dropdown on outside click ----------
	useEffect(() => {
		const handleClickOutside = (e) => {
			if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
				setDropdownOpen(false);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);

	// --------------------------------------------------

	return (
		<div className={`phone-input-container ${className}`.trim()}>
			<div className="phone-dropdown" ref={dropdownRef}>
				<button
					type="button"
					className="phone-dropdown-btn"
					onClick={() => setDropdownOpen((prev) => !prev)}
				>
					{countryLabel}
					<span className={`arrow ${dropdownOpen ? "open" : ""}`}>▼</span>
				</button>
				{dropdownOpen && (
					<ul className="phone-dropdown-list">
						{COUNTRIES.map(({ label, value }) => (
							<li
								key={label}
								className="phone-dropdown-item"
								onClick={() => handleSelect(label, value)}
							>
								{label}
							</li>
						))}
					</ul>
				)}
			</div>

			<input
				type="tel"
				className="phone-input input"
				placeholder="555-123-4567"
				value={localNumber}
				onChange={handleChange}
			/>
		</div>
	);
};

export default PhoneInput;

